module.exports = __webpack_public_path__ + "img/css3.27a0c24b.svg";